import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { AccountRolesRouter } from "./Router";

export function AccountRolesContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <AccountRolesRouter />
    </ThemeProvider>
  );
}
